export const getRouteSummaryUrl =
  "/api/v3/org/road_stretch/:roadStretchId/metrics";
export const downloadRouteAnalysisPdfReportUrl =
  "/api/v3/org/road_stretch/:roadStretchId/metrics/pdf";
